import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type InfoColumnProps = {
  label: string;
  value: string | number;
  labelColor?: string;
  icon?: ReactNode;
};

export function InfoColumn({
  label,
  value,
  labelColor,
  icon,
}: InfoColumnProps) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      {icon}

      <Box display="flex" flexDirection="column">
        <Typography
          fontWeight={600}
          fontSize="1rem"
          color={labelColor}
        >
          {label}
        </Typography>

        <Typography fontWeight={600} fontSize="1rem">
          {value}
        </Typography>
      </Box>
    </Stack>
  );
}
